import { useCallback, useEffect, useState } from 'react';
import { useAxios } from '../../Helpers/AxiosHelper';
import { Dropdown, DropdownChangeEvent, ProgressSpinner } from '../../Common/Imports';
import { ApiResponse, Brands_EXT, DDModel } from '../../Models/Classes';


interface DDBrandsProps {
    IdStakeholder?: number | null;
    onChange?: (IdBrand: number | undefined) => void;
    value?: number;
    onBlur?: () => void;
    showClear?: boolean;
}

export const DDBrands: React.FC<DDBrandsProps> = ({ value, onChange, IdStakeholder = "", showClear = false }) => {
    const [data, setData] = useState<DDModel<Brands_EXT>[] | undefined>();
    const [selectedElem, setSelectedElem] = useState<DDModel<Brands_EXT> | undefined>();
    const AxiosHelper = useAxios();

    const GetData = useCallback(async () => {
        try {
            const resp = await AxiosHelper.get<ApiResponse<DDModel<Brands_EXT>[]>>(`DropDown/StakeholderBrands?IdStakeholder=${IdStakeholder}`);
            if (resp.data.code === 0) {
                setData(resp.data.data);
            }
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    }, [AxiosHelper, IdStakeholder]);

    useEffect(() => {
        GetData();
    }, [GetData]);


    useEffect(() => {
        setSelectedElem(data?.find(m => m.id === value));
    }, [data, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<Brands_EXT>;
        setSelectedElem(_val);
        if (onChange && e) {
            const id = _val.id as number
            onChange(id);
        }
    };

    return (

        data ?
            <Dropdown
                value={selectedElem}
                onChange={handleChange}
                options={data}
                showClear={showClear }
                optionLabel="label"
                className="w-100" />
            :
            <ProgressSpinner style={{ width: '35px', height: '35px' }} />

    );
};
